import { createMmWsAction } from '@skynet/data-ws-mm';
import { LoanFundsCommands } from './types';

export interface AddCommittedFundsPayload {
  loanID: string;
  amount: number;
  token: string;
}

export const addCommittedFunds = createMmWsAction<
  AddCommittedFundsPayload,
  AddCommittedFundsPayload
>('loans/addCommittedFunds', (data) => ({
  command: LoanFundsCommands.AddCommittedFunds,
  ...data,
}));
